import React from 'react'

import NotificationsPage from '@SonarCX/pages/Notifications/Page'

import useStyles from './styles'

type NotificationsProps = {
  rootRef: React.RefObject<HTMLDivElement>
}

const NotificationsTab: React.FC<NotificationsProps> = ({ rootRef }) => {
  const classes = useStyles()

  return (
    <NotificationsPage rootRef={rootRef} hideTitle className={classes.root} />
  )
}

export default NotificationsTab
